// extracted by mini-css-extract-plugin
module.exports = {"container":"Counters_container__HmmcS","item":"Counters_item__nFtdf","delimiter":"Counters_delimiter__rez2A"};